/**
 * @typedef {import("../types")} CTypes
 */

/** @type {CTypes.ShipTiers} */
import ShipTiers from '../assets/json/shiptiers.json';
/** @type {CTypes.TierNames} */
import TierNames from '../assets/json/tierNames.json';

/**
 *
 * @param shipName {string|undefined}
 * @returns {number}
 */
export function getShipTierFromName(shipName) {
  if (shipName === undefined) {
    return 0;
  }
  for (const hullTierList of Object.values(ShipTiers)) {
    for (let i = 0; i < hullTierList.length; i++){
      const shipList = hullTierList[i];
      if (shipList.includes(shipName)) {
        return i;
      }
    }
  }
  throw new Error(`Could not find tier for ${shipName}`);
}

/**
 *
 * @param tier {number}
 * @returns {string}
 */
export function tierToName(tier) {
  return TierNames[tier];
}

export function getShipTagsFromName(shipName) {
  const shipInfo = getShipInfo(shipName);
  return shipInfo.roles;
}

/**
 * @param shipName {string}
 * @returns {CTypes.ShipInfo}
 */
export function getShipInfo(shipName) {
  return require("assets/json/ship_info/" + shipName + ".json")
}

/**
 * @param shipName {string}
 * @returns {CTypes.ShipJson}
 */
export function getShipJSON(shipName) {
  return require("assets/json/ship/" + shipName + ".json")
}

/**
 *
 * @param shipName {string}
 * @param kai {boolean}
 * @param banner {boolean}
 */
export function getShipImage(shipName, kai, banner) {
  const fileName = shipName + (kai ? "kai" : "") + (banner ? "banner" : "icon") + ".png";

  return require("assets/img/ship_images/" + fileName);
}

/**
 *
 * @param shipJson {CTypes.ShipJson}
 * @return {string}
 */
export function getShipWikiLink(shipJson) {
  return "https://azurlane.koumakan.jp/wiki/" + shipJson.Name.replace(/\s/g, "_");
}

/**
 *
 * @param shipJson {CTypes.ShipJson}
 * @return {string}
 */
export function getLinkShipName(shipJson) {
  return shipJson.Name.replace(/\s/g, "_").toLowerCase();
}

/**
 *
 * @param shipJson {CTypes.ShipJson}
 * @param isKai {boolean}
 * @return {string}
 */
export function getShipRarityCSSClass(shipJson, isKai) {
  const normalizedRarity = shipJson.Rarity.toLowerCase().replace(/\s/g, "-");

  if (isKai) {
    if (normalizedRarity === 'normal') {
      return "rarity-rare";
    } else if (normalizedRarity === 'rare') {
      return "rarity-elite";
    } else if (normalizedRarity === 'elite') {
      return "rarity-super-rare";
    } else if (normalizedRarity === 'super-rare') {
      return "rarity-ultra-rare";
    }
  }

  return "rarity-" + normalizedRarity;
}

/**
 *
 * @param shipInfo {CTypes.ShipInfo}
 * @param shipJson {CTypes.ShipJson}
 * @return {boolean}
 */
export function isShipKai(shipInfo, shipJson) {
  return shipJson.HealthKai > 0 && !shipInfo.hideKai;
}